import { PieChart } from './PieChart'
import { withPieChart } from './withPieChart'

const Connected = withPieChart(PieChart)

export { Connected as PieChart }
